import React, { useEffect, useState } from 'react';

/** Indeterminate feedback: providers do not report measurable completion. */
export function LoadingNotice({
  label,
  detail,
  slow = false,
}: {
  label: string;
  detail?: string;
  slow?: boolean;
}) {
  const [takingLonger, setTakingLonger] = useState(false);
  useEffect(() => {
    if (!slow) return;
    const timer = window.setTimeout(() => setTakingLonger(true), 8000);
    return () => window.clearTimeout(timer);
  }, [slow]);
  return (
    <div className="catalogue-loading-notice" role="status" aria-live="polite">
      <span className="catalogue-loading-indicator" aria-hidden="true" />
      <div>
        <p className="text-sm font-semibold">{label}</p>
        {(detail || takingLonger) && (
          <p className="mt-1 text-xs leading-5 text-ink-muted">
            {takingLonger
              ? 'This provider is taking longer than usual. Your review is still here.'
              : detail}
          </p>
        )}
      </div>
    </div>
  );
}

export function SearchSkeleton() {
  return (
    <div className="provider-results-grid" aria-hidden="true">
      {[0, 1, 2].map((item) => (
        <div key={item} className="rounded-xl border border-line/65 p-4">
          <div className="catalogue-skeleton h-40 rounded-lg" />
          <div className="catalogue-skeleton mt-4 h-5 w-4/5 rounded" />
          <div className="catalogue-skeleton mt-3 h-3 w-3/5 rounded" />
          <div className="catalogue-skeleton mt-5 h-3 w-2/5 rounded" />
        </div>
      ))}
    </div>
  );
}

export function ReviewSkeleton() {
  return (
    <section className="admin-panel min-w-0 p-5 sm:p-6" aria-label="Loading publication request">
      <LoadingNotice
        label="Opening publication request…"
        detail="Loading the submitted edition and catalogue matches."
      />
      <div aria-hidden="true" className="mt-6">
        <div className="catalogue-skeleton h-8 w-3/5 rounded" />
        <div className="catalogue-skeleton mt-3 h-4 w-2/5 rounded" />
        <div className="catalogue-skeleton my-7 h-12 rounded-xl" />
        <div className="grid grid-cols-2 gap-4">
          <div className="catalogue-skeleton h-12 rounded-xl" />
          <div className="catalogue-skeleton h-12 rounded-xl" />
        </div>
        <div className="catalogue-skeleton mt-4 h-12 rounded-xl" />
      </div>
    </section>
  );
}
